import React from 'react'
import AuthorDesktop from './components/AuthorDesktop'
import AuthorTablet from './components/AuthorTablet'
import AuthorMobile from './components/AuthorMobile'

const Author: React.FC = () => {
  return (
    <>
      <div className="hidden lg:block">
        <AuthorDesktop />
      </div>
      <div className="hidden md:block lg:hidden">
        <AuthorTablet />
      </div>
      <div className="block md:hidden">
        <AuthorMobile />
      </div>
    </>
  )
}

export default Author